import React from 'react';

import './button_component.scss';

const ButtonComponent = (props) => {
    
    return (
        <div>
            <button type="button" aria-label={props.label} className={props.tipo} disabled={props.disabled} onClick={props.action}>
                {props.nombre}
            </button>
        </div>
    )

}

export default ButtonComponent
